import _ from "lodash";
import { ISize } from "../types";
import { getSizeLabel } from "containers/legacy-cart/helpers/gridEntry";
import type { IProduct } from "types/product";

export const getUniqSizes = (product: IProduct): ISize[] =>
    _.uniqBy(
        _.map(product.sizes, (size) => ({
            id: size.size,
            name: getSizeLabel(size),
        })),
        "id"
    );
